'use client';

import { useRef } from 'react';

import type { ActionBoxData } from '@zoomit/editor';
import { Box } from '@zoomit/primitives';
import { ActionBoxBlockData } from '@zoomit/web-kit';

import { MovingBorder } from '../../../helpers/handleAnimatedBorder';

export type ActionBoxBlockProps = {
  blockData: ActionBoxData;
  template: 'animated' | 'simple' | 'small';
};

export const ActionBoxBlock = (props: ActionBoxBlockProps) => {
  const { blockData, template } = props;
  const ref = useRef<HTMLDivElement>(null);

  if (template === 'animated') {
    return (
      <div ref={ref}>
        <Box className={'bg-grey6 relative overflow-hidden rounded-sm border-transparent p-1'}>
          <div className="absolute inset-0 rounded-full blur-[7px]">
            <MovingBorder className={'fill-primary1'} ref={ref} />
          </div>
          <ActionBoxBlockData blockData={blockData} className={'p-8'} />
        </Box>
      </div>
    );
  }

  return (
    <Box className={'border-r-primary1 border-r-4'}>
      <ActionBoxBlockData blockData={blockData} className={'p-6'} />
    </Box>
  );
};
